import { render, staticRenderFns } from "./DashboardOptionalFilters.vue?vue&type=template&id=0f734b39&scoped=true"
import script from "./DashboardOptionalFilters.vue?vue&type=script&lang=js"
export * from "./DashboardOptionalFilters.vue?vue&type=script&lang=js"
import style0 from "./DashboardOptionalFilters.vue?vue&type=style&index=0&id=0f734b39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f734b39",
  null
  
)

export default component.exports